import {
  type AssessmentRequest,
  type AssessmentResult,
  type TestConnectionResponse,
} from '../types/assessment';

const API_BASE = import.meta.env.VITE_API_URL || '/api';

async function fetchApi<T>(path: string, options: RequestInit = {}): Promise<T> {
  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
  });

  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Unknown error' }));
    throw new Error(error.message || `API error: ${response.status}`);
  }

  return response.json();
}

export async function testConnection(
  request: AssessmentRequest
): Promise<TestConnectionResponse> {
  return fetchApi<TestConnectionResponse>('/test-connection', {
    method: 'POST',
    body: JSON.stringify(request),
  });
}

export async function runAssessment(
  request: AssessmentRequest
): Promise<AssessmentResult> {
  return fetchApi<AssessmentResult>('/assess', {
    method: 'POST',
    body: JSON.stringify(request),
  });
}
